<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

import axios from "axios";
import Swal from "sweetalert2";

/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Profile",
      items: [
        {
          text: "Profile",
          active: true
        }
      ],
      form: {
        username: "",
        name: "",
        contact_no: "",
        gender_id: 0,
        password: "",
      },
      form_password: {
        old_password: ""
      },
      genders: [],
      submitted: false,
      isLoadingPost: false,
      token: null,
      passwordType: 'password',
      popupPasswordType: 'password',
      list_error_messages: []
    };
  },
  validations: {
    form: {
      username: { required },
      name: { required },
      contact_no: { required }
    },
    form_password: {
      old_password: { required }
    }
  },
  async mounted() {
    this.token = await localStorage.getItem('authToken')

    this.getGenders();

    this.form.username = this.$store.getters['auth/loggedIn'].username;
    this.form.name = this.$store.getters['auth/loggedIn'].name;
    this.form.contact_no = this.$store.getters['auth/loggedIn'].contact_no;
    this.form.gender_id = this.$store.getters['auth/loggedIn'].gender_id ? this.$store.getters['auth/loggedIn'].gender_id : 0

  },
  methods: {
    getGenders(){
      axios.get(process.env.VUE_APP_API + '/gender')
      .then(res => {
        this.genders = res.data.data;

        this.genders.unshift({
          id: 0,
          name: 'Select one of the genders'
        });
      })
      .catch(err => {
        this.err = err;
      });
    },
    formSubmit() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.form.$invalid) {
        return 
      }

      if(this.form.password !== ""){
        this.list_error_messages = []
        this.$bvModal.show('modal-data');
        return 
      }

      this.submitForm();
    },
    submitForm(){
      this.isLoadingPost = true;

      axios.post(process.env.VUE_APP_API + '/user/update', {
        ...this.form,
        old_password: this.form_password.old_password,
        _method: "PUT"
      }, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then(res => {
        Swal.fire("Updated!", "Your Profile has been updated", "success");
        this.$bvModal.hide('modal-data');
        this.list_error_messages = []
      })
      .catch(err => {
        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              this.list_error_messages = []
              this.list_error_messages.push(err.response.data.message)
            }
          }
        }
      })
      .finally(() => {
        this.isLoadingPost = false;
      });
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">Welcome Back!</h5>
                  <p>Avava Calendar App</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <div class="avatar-md">
                    <span class="avatar-title rounded-circle font-size-20">{{$store.getters['auth/loggedIn'].name.charAt(0)}}</span>
                  </div>
                </div>
                <h5 class="font-size-15 text-truncate">{{$store.getters['auth/loggedIn'].name}}</h5>
                <p class="text-muted mb-0 text-truncate">I'm an <strong><u>{{$store.getters['auth/loggedIn'].role}}</u></strong></p>
              </div>

              <div class="col-sm-8">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="modal-data" title="Change Password" title-class="font-18" hide-footer>
        <form class="needs-validation" @submit.prevent="submitForm">
          <div class="row mb-4">
            <div class="col-12">
              <b-alert class="mb-1" show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
                {{ err }}
              </b-alert>
            </div>
            <div class="col-12 mb-4">
              You are about to change your account's password. To continue, please input your old password.
            </div>
            <div class="col-12">
              <label for="inputOldPassword">Input Old Password <span class="text-danger small">*</span></label>
              <input
                id="inputOldPassword"
                v-model="form_password.old_password"
                :type="popupPasswordType"
                class="form-control"
                placeholder="Enter old password"
                :class="{
                  'is-invalid': submitted && $v.form_password.old_password.$error,
                }"
              />
              <b-form-checkbox v-model="popupPasswordType" value="text" unchecked-value="password" class="mt-1">
                <span class="ps-2">Show Password</span>
              </b-form-checkbox>
            </div>
            <div class="col-12 small">
              <div class="text-muted">If you forget your old password, kindly request <strong>Admnistrator</strong> to change your password.</div>
            </div>
          </div>
          <div class="col-12 right">
            <button :disabled="isLoadingPost" class="btn btn-primary me-2" type="submit">Submit</button>
            <!-- <button :disabled="isLoadingPost" class="btn btn-light" @click="$bvModal.hide('modal-data')">Close</button> -->
          </div>
        </form>
      </b-modal>

      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Personal Information</h4>
            <form class="needs-validation" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="inputUsername">Username <span class="text-danger small">*</span></label>
                    <input
                      id="inputUsername"
                      v-model="form.username"
                      type="text"
                      class="form-control"
                      placeholder="Use for login e.g. ronni123"
                      :class="{
                        'is-invalid': submitted && $v.form.username.$error,
                      }"
                    />
                    <div v-if="submitted && $v.form.username.$error" class="invalid-feedback">
                      <span v-if="!$v.form.username.required">Username is required.</span>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="mb-3">
                      <label for="inputField2">Password</label>
                      <input
                        id="inputField2"
                        v-model="form.password"
                        :type="passwordType"
                        class="form-control"
                        placeholder="Password"
                      />
                      <b-form-checkbox v-model="passwordType" value="text" unchecked-value="password" class="mt-1">
                        <span class="ps-2">Show Password</span>
                      </b-form-checkbox>

                      <div class="mt-1">
                        <small class="text-muted">Enter new password to be used when login.</small>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="inputName">Name <span class="text-danger small">*</span></label>
                    <input
                      id="inputName"
                      v-model="form.name"
                      type="text"
                      class="form-control"
                      placeholder="Name"
                      :class="{
                        'is-invalid': submitted && $v.form.name.$error,
                      }"
                    />
                    <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
                      <span v-if="!$v.form.name.required">Name is required.</span>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="inputContact">Contact No. <span class="text-danger small">*</span></label>
                    <input
                      id="inputContact"
                      v-model="form.contact_no"
                      type="text"
                      class="form-control"
                      placeholder="Contact No."
                      :class="{
                        'is-invalid': submitted && $v.form.contact_no.$error,
                      }"
                    />
                    <div v-if="submitted && $v.form.contact_no.$error" class="invalid-feedback">
                      <span v-if="!$v.form.contact_no.required">Contact No. is required.</span>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="inputGender">Select Gender</label>
                    <select
                      id="inputGender"
                      v-model="form.gender_id"
                      class="form-control">
                      <option :value="gender.id" v-for="(gender, index) in genders" :key="`gender_${index}`">{{gender.name}}</option>
                    </select>
                  </div>
                  
                  <b-alert class="mb-3" show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
                    {{ err }}
                  </b-alert>

                  <div class="col-12">
                    <button :disabled="isLoadingPost" class="btn btn-primary me-2" type="submit">Submit</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>